/*jshint esversion: 6 */
/* global interact */
import { Controller } from "stimulus";
import Sortable from 'sortablejs';
import { htmlToElement } from '.././helpers/dom';

export default class extends Controller {
  static targets = [ "schoolSubjectAreaTemplate", "schoolSubjectAreasFormContainer", "schoolSubjectAreaName", "schoolSubjectAreaForm" ]

  connect() {
    // if (this.hasSchoolSubjectAreaFormTarget) {
    //   // Show the first skill category while all others are hiding
    //   this.schoolSubjectAreaFormTargets[0].classList.toggle('hidden');
    // }

    // Make the skill category selectors sortable
    const sortable = document.querySelector('#school-subject-areas-sortable.sortable');
    var el = Sortable.create(sortable, {
      animation: 150,
      draggable: "li.btn",
      filter: ".ignore-sort",
      forceFallback: true,
      onEnd: function(event) {
        let schoolSubjectAreaId = event.item.getAttribute('data-school-field-id');
        document.querySelector(`[data-school-field-id="${schoolSubjectAreaId}"] input.position`).value = event.newIndex + 1;
      }
    });

    // Highlight initial skill category
    // document.querySelector('#school-subject-areas-sortable.sortable li').classList.add('btn-pink');
  }

  switchTo(event) {
    this.schoolSubjectAreaFormTargets.forEach((el, i) => {
      el.classList.toggle("hidden", el.dataset.schoolSubjectAreaId != event.target.dataset.schoolSubjectAreaId)
    });

    // Highlight selected tab
    let sortableSelector = '#school-subject-areas-sortable.sortable li.btn-pink'
    if (document.querySelector(sortableSelector) != null) {
      document.querySelector(sortableSelector).classList.remove('btn-pink');
    }
    event.target.classList.add('btn-pink');
  }

  addNewItem(event) {
    const id = new Date().getTime();
    const template = `<li class='inline-block mr-10 mb-14 btn' data-target='schools--school-subject-areas.schoolSubjectAreaName' data-action='click->schools--school-subject-areas#switchTo' data-school-subject-area-id='${id}'>New Subject Area</li>`
    const newElementLink = htmlToElement(template);
    const parentElement = document.getElementById("school-subject-areas-sortable");
    parentElement.insertAdjacentElement("beforeend", newElementLink);
    newElementLink.addEventListener("click", (ev) => {
      this.switchTo(ev);
    });
    const newElementForm = htmlToElement(this.schoolSubjectAreaTemplateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, id));
    newElementForm.dataset.schoolSubjectAreaId = id;
    this.schoolSubjectAreasFormContainerTarget.insertAdjacentElement('beforeend', newElementForm);

    window.expandableTextArea();
    newElementLink.click();
  }

  updateTitle(event) {
    const schoolSubjectAreaId = event.target.parentElement.parentElement.parentElement.dataset.schoolSubjectAreaId;
    this.schoolSubjectAreaNameTargets.find(el => el.dataset.schoolSubjectAreaId  == schoolSubjectAreaId).innerText = event.target.value;
  }

  removeItem(event) {
    if (confirm('Are you sure?') == true) {
      const itemForm = event.target.parentElement;
      const schoolSubjectAreaId = itemForm.dataset.schoolSubjectAreaId;
      this.schoolSubjectAreaNameTargets.find(el => el.dataset.schoolSubjectAreaId  == schoolSubjectAreaId).style.display = 'none';
      itemForm.querySelector("input[name*='_destroy']").value = 1;
      itemForm.style.display = 'none';
    }
  }

  _insertBefore(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
  }

  _insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
  }
}
